import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { DASHBOARD_WIDGET_SPACING } from '../../../../constants/dashboardWidgetSpacing'

export const EInvoicingBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 1;
  gap: ${Spacing.S24};
  width: 100%;
  height: 104px;
  margin: ${DASHBOARD_WIDGET_SPACING / 2}px 0;
  border-radius: ${BorderRadius.R12};
  position: relative;
  background-color: ${Color.Green100};
  overflow: hidden;
`

export const IllustrationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  padding-left: ${Spacing.S4};
`

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`

export const TextWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`

export const CtaWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-right: ${Spacing.S40};
`

export const CloseIconWrapper = styled.div`
  position: absolute;
  top: ${Spacing.S8};
  right: ${Spacing.S8};
`
